module.exports = __webpack_public_path__ + "static/chat-8d802c8b98eb62204ab35c7706e1234a.png";